import time from './time';
import mtTime from './mtTime';
import amount from './amount';
import contact from './contact';
import uuid from './uuid';
import lagName from './lagName';
import string from './string';

export default {
    contact,
    time,
    mtTime,
    amount,
    uuid,
    lagName,
    string,
};
